import { useEffect, useLayoutEffect } from 'react';

const isBrowser = typeof window !== 'undefined';

/**
 * This hook uses `useLayoutEffect` on the client side (browser)
 * and `useEffect` on the server side (SSR) to avoid hydration errors.
 */
export const useIsomorphicLayoutEffect = isBrowser
  ? useLayoutEffect
  : useEffect;
